import React, { useState, useMemo, useEffect } from "react"
import { useMemoizedFn } from "ahooks";
import { Form, Message } from '@bedrock/components';
import { useOpenModal } from "#utils/openModal";
import NoteList from '@mpc/common/src/features/NoteList';
import { mainSupplierQueryRiskRemark, mainSupplierQuerySupplierComment } from "#services/api";
import "./index.less"



type Props = {
    id?: string;
    record?: {
        main_supplier_id: number;
        main_supplier_name?: string;
        supplier_name?: string;
    };
    noteType?: string;
}

export const useSupplierRemarkModal = () => {
    const [props, setProps] = useState<Props>({})
    const [loading, setLoading] = useState(false)
    const [state, setState] = useState({ data: [], name: '' })
    const { record, noteType = 'risk_remarks' } = props
    useEffect(() => {
        if (!record?.main_supplier_id) return
        setLoading(true)
        if (noteType === 'risk_remarks') {
            mainSupplierQueryRiskRemark({ id: record?.main_supplier_id }).then(res => {
                if (res.code === 1) {
                    setState({ data: res?.data || [], name: '风险备注' })
                }
            }).catch(err => {
                Message.error(err.Message)
            }).finally(() => {
                setLoading(false)
            })

        } else if (noteType === 'supplier_comments') {
            mainSupplierQuerySupplierComment({ id: record?.main_supplier_id }).then(res => {
                if (res.code === 1) {
                    setState({ data: res?.data || [], name: '供应商备注' })
                }
            }).catch(err => {
                Message.error(err.Message)
            }).finally(() => {
                setLoading(false)
            })
        }
    }, [noteType, record])

    const text = `${record?.main_supplier_name || record?.supplier_name}-${state?.name} (${state.data.length})`

    const { open, destroy } = useOpenModal({
        width: 800,
        className: 'note-list-modal',
        title: <div className="title-modal" title={text}>{text}</div>,
        okButton: false,
        cancelButton: false,
        maskClosable: false,
        footer: null,
        children: <NoteList loading={loading} list={state?.data} />,
        destroyOnClose: true,
        onOk: () => { }
    })

    const openSupplierRemarkModal = useMemoizedFn((props: Props) => {
        setProps(props);
        open()
    })

    return openSupplierRemarkModal
}
